var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 9.58341C1.66675 10.623 1.87152 11.6525 2.26937 12.613C2.66722 13.5735 3.25036 14.4462 3.98549 15.1813C4.72062 15.9165 5.59334 16.4996 6.55384 16.8975C7.51433 17.2953 8.54378 17.5001 9.58341 17.5001C10.623 17.5001 11.6525 17.2953 12.613 16.8975C13.5735 16.4996 14.4462 15.9165 15.1813 15.1813C15.9165 14.4462 16.4996 13.5735 16.8975 12.613C17.2953 11.6525 17.5001 10.623 17.5001 9.58341C17.5001 8.54378 17.2953 7.51433 16.8975 6.55384C16.4996 5.59334 15.9165 4.72062 15.1813 3.98549C14.4462 3.25036 13.5735 2.66722 12.613 2.26937C11.6525 1.87152 10.623 1.66675 9.58341 1.66675C8.54378 1.66675 7.51433 1.87152 6.55384 2.26937C5.59334 2.66722 4.72062 3.25036 3.98549 3.98549C3.25036 4.72062 2.66722 5.59334 2.26937 6.55384C1.87152 7.51433 1.66675 8.54378 1.66675 9.58341Z",
    stroke: "white",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 16.6667L18.3334 18.3334",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.08cde7be997ac887dfb48897fb27a24a.svg";
export { ForwardRef as ReactComponent };